import { type FC } from "react";
import { Link } from "@root/shared/components/Link";
import * as styles from "./styles.css";

type Props = {
  lineUrl: string;
};

export const PromoteLine: FC<Props> = ({ lineUrl }) => {
  return (
    <div className={styles.box}>
      <div className={styles.textWrapper}>
        <p className={styles.text}>
          <span className={styles.lineText}>LINE</span>で応募やメッセージの
          <br />
          通知を受け取る
        </p>
      </div>
      <div className={styles.linkWrapper}>
        <Link theme="line" href={lineUrl} target="_blank" className={styles.link}>
          LINE連携する
        </Link>
      </div>
    </div>
  );
};
